import { render, staticRenderFns } from "./simNotice.vue?vue&type=template&id=3f4a0f45&scoped=true&"
import script from "./simNotice.vue?vue&type=script&lang=js&"
export * from "./simNotice.vue?vue&type=script&lang=js&"
import style0 from "./simNotice.vue?vue&type=style&index=0&id=3f4a0f45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a0f45",
  null
  
)

export default component.exports